import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTiposElenco } from 'services/servicioGet';
import { TipoElenco } from 'utils/models/types';

interface TiposElencoState {
  tiposElenco: TipoElenco[];
  loadingTiposElenco: boolean;
  errorTiposElenco: string | null;
}

// Estado inicial del slice
const initialState: TiposElencoState = {
  tiposElenco: [],
  loadingTiposElenco: false,
  errorTiposElenco: null,
};

// Thunk para obtener los tipos de elenco
export const fetchTiposElenco = createAsyncThunk<TipoElenco[], void, { rejectValue: string }>(
  'fetchTiposElenco',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTiposElenco();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de tipos de elenco
const tiposElencoSlice = createSlice({
  name: 'tiposElenco',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTiposElenco.pending, state => {
        state.loadingTiposElenco = true;
        state.errorTiposElenco = null;
      })
      .addCase(fetchTiposElenco.fulfilled, (state, action) => {
        state.tiposElenco = action.payload;
        state.loadingTiposElenco = false;
      })
      .addCase(fetchTiposElenco.rejected, (state, action) => {
        state.loadingTiposElenco = false;
        state.errorTiposElenco = action.payload as string;
      });
  },
});

export default tiposElencoSlice.reducer;
